import { useEffect, useState } from "react";
import ReactModal from "react-modal";
import useKeypress from "../ownHooks/pressEsc";
import { MyCancelButton, MyNewButton, MySaveButton } from "../StyleSheets/GeneralButtonStyles";
import { MyModalButtons, MyModalCloseButton, MyModalContentRow, MyModalContentSelectInput, MyModalContentTextInput, MyModalForm } from "../StyleSheets/ModalStyle";
import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";

var MonitorApi = require('monitor-api');

export default function LinieCreate({ instance, reloadData, vmInstance }) {
    const [newLinie, setNewLinie] = useState(new MonitorApi.CreateLinie());
    const [showModal, setShowModal] = useState(false);
    const [dataVm, setDataVm] = useState([]);


    useEffect(() => {
        vmInstance.getVerkehrsmittelVerkehrsmittelGet((error, data) => {
            if (error) {
                console.log(error);
            } else {
                setDataVm(data);
            }
        });
    }, [setDataVm, vmInstance]);

    useKeypress('Escape', () => {
        closeModal();
    });

    const openModal = () => {
        setNewLinie(new MonitorApi.CreateLinie());
        setShowModal(true);
    }

    const closeModal = () => {
        setShowModal(false);
    }

    const changingInput = event => {
        event.preventDefault();
        setNewLinie(previous => ({ ...previous, [event.target.name]: event.target.value }))
    }

    const submitForm = event => {
        event.preventDefault();
        let creating = new Promise((resolve) => {
            instance.createLinieLiniePost(newLinie, (error, data, response) => {
                if (error) {
                    FehlerauswertungErrResp(error, response);
                    resolve(error);
                } else {
                    alert(`Neue Linie ${data.name} hinzugefügt.\nMit id: ${data.id}`);
                    resolve(data);
                }
            })
        })
        creating.then((msg) => {
            closeModal();
            reloadData();
        })
    }

    return (
        <div>
            <MyNewButton onClick={openModal}>&#43; neue Linie</MyNewButton>
            <ReactModal isOpen={showModal} className="modal">
                <MyModalCloseButton onClick={closeModal}>&#10007; </MyModalCloseButton>
                <MyModalForm onSubmit={submitForm}>
                    <h3>Neue Linie:</h3>
                    <MyModalContentRow >
                        <label>Bezeichnung:
                            <MyModalContentTextInput name="linie" onChange={changingInput} required />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow >
                        <label>Verkehrsmittel:
                            <MyModalContentSelectInput name="idVm" onChange={changingInput} required>
                                <option key={0} defaultValue hidden value="">---Auswahl treffen---</option>
                                {dataVm.map(vm => <option value={vm.id} key={vm.id}>{vm.mittel}</option>)}
                            </MyModalContentSelectInput>
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow >
                        <label>Kommentar:
                            <MyModalContentTextInput name="kommentar" onChange={changingInput} required={false} />
                        </label>
                    </MyModalContentRow>
                    <MyModalButtons>
                        <MySaveButton type="submit">Speichern</MySaveButton>
                        <MyCancelButton onClick={closeModal}>Abbruch</MyCancelButton>
                    </MyModalButtons>
                </MyModalForm>
            </ReactModal>
        </div>
    )
}